<style scoped lang="scss">
    .p {
        background: #F5F5F5;
        border: 1px solid #E8E8E8;
        border-radius: 4px;
    }
</style>

<template>
    <div>
        <v-title :title="title" style="margin-left: -15px">
            <span v-if="this.referralStatus === 'REFUSED'" style="color: #19B8AF;">（资料未就绪状态不能开启会诊）</span>
        </v-title>
        <template v-if="this.referralStatus === 'REFUSED'">
            <el-radio disabled v-model="radio" label="2">安排转诊</el-radio>
            <el-radio disabled v-model="radio" label="1">拒绝转诊</el-radio>
        </template>
        <div class="p color_red fs14 pl15 pr15 pt5 pb5 mt20">
            {{value.refuseReason}}
        </div>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";

  export default {
    name: "referral-disagree-form",
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      referralStatus: String,
      value: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        form: {}
      }
    },
    computed: {
      title() {
        return this.referralStatus === 'REFUSED' ? '资料审核' : '取消原因';
      },
        radio(){
            return this.referralStatus === 'REFUSED' ? '1' : '2';
        }
    },
    created() {
    },
    components: {VTitle},
    watch: {},
    methods: {},
  }
</script>

<style scoped>

</style>
